export const TYPE_METRIC = 'metric'; // for render values that are metrics, sometimes required calculation
export const TYPE_SCALAR = 'scalar'; // for render pure values, usually from backend
export const TYPE_MEDIA = 'media'; // for render media content, like images
export const TYPE_CUSTOM = 'custom'; // for render custom layout
